module.exports = __webpack_public_path__ + "static/media/andres.217ac3a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about-us/andres.png
// module id = 1165
// module chunks = 0